import React from 'react';

// Crisp, scalable ENERSIDER wordmark. Font size is controlled by the parent className.
export default function Logo({ light = false, className = '' }) {
  const ink = light ? 'text-white' : 'text-[#111111]';
  const dot = light ? 'text-white/55' : 'text-neutral-400';
  return (
    <span className={`font-logo tracking-[-0.03em] leading-none select-none inline-flex items-baseline ${className}`}>
      <span className={ink}>ENER</span>
      <span className="text-[#D01919]">S</span>
      <span className={ink}>IDER</span>
      <span className={`${dot} text-[0.42em] ml-[0.06em] tracking-tight`}>.com</span>
    </span>
  );
}
